module.exports = __webpack_public_path__ + "img/138ne.b8c1043d.svg";